'use es6';

export const getIsAcademyToSoftwareModalOpen = state => state && state.academyToSoftware && state.academyToSoftware.isModalOpen;
export const getAcademyToSoftwareModalTriggerSource = state => state && state.academyToSoftware && state.academyToSoftware.modalTriggerSource;
export const getAcademyToSoftwareShowTooltip = state => state && state.academyToSoftware && state.academyToSoftware.showTooltip;